const state = {
    commissions: [],
    itens: [],
    item: {
        id: null,
        name: '',
        module_id: '',
        functionalities: [],
        module: {
            id: null,
            name: '',
            icon: ''
        },
        goals : []
    }
};

export default state;